<template>
  <b-container fluid>
    <b-table
      v-if="complexen && filterComplexen.length < 50"
      ref="complexTable" 
      :caption="`${filterComplexen.length} complexen komen overeen met de zoekterm`"
      :items="filterComplexen"
      :fields="[{ label: 'Complexnummer', key:'Nr' }, { label:'Relatie', key:'Re' }, { label:'Aantal', key:'Qu' }]"
      caption-top
      selectable
      select-mode="single"
      bordered
      hover
      @row-selected="rowSelected"
    >
      <template #cell(Nr)="row">
        {{ row.item.Nr }}
      </template>
    </b-table>
    <b-alert :show="filterComplexen.length >= 50">
      Meer dan 50 complexen gevonden! Maak de zoekterm specifieker.
    </b-alert>
  </b-container>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin";
export default {
  mixins: [serviceMixin],
  props: {
    groep: {
      type: String,
      default: "D",
    },
    zoekterm: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      complexen: [],
    };
  },
  computed: {
    filterComplexen: function () {
      return this.complexen.filter(
        (item) => item.Nr.toLowerCase().search(this.zoekterm.toLowerCase()) > -1
      );
    },
  },
  watch: {
      groep: function() {
          this.getComplexen();
      }
  },
  mounted() {
    this.getComplexen();
  },
  methods: {
    rowSelected(record) {
      this.$emit('complex-geselecteerd',record[0]);
    },
    getComplexen() {
      var vm = this;
      this.get("/complexen/" + this.groep)
        .then(function (response) {
          console.log(response);
          vm.complexen = response.data.complexen;
        })
        .catch(function (error) {
          vm.error = error;
        });
    },
  },
};
</script>